import { getMqString as mqString, } from '@haaretz/htz-css-tools';
import bps from '../consts/bps';

export default function getMqString(query, noMediaPrefix, pixelOutput) {
  return mqString(bps, query, noMediaPrefix || false, pixelOutput);
}
